export default "__VITE_ASSET__DYxGMahd__"